import ItemResults from "./ItemResults"
import React, { useState } from "react"
import ReactPaginate from "react-paginate"

const NP_ITEM_PAGE = 6

function SearchResults({ results, openJob, nopage }) {
    const [list, setList] = useState(results.slice(0, NP_ITEM_PAGE))

    function handlePageClick(data) {
        let selected = data.selected
        let offset = Math.ceil(selected * NP_ITEM_PAGE)
        setList(results.slice(offset, offset + NP_ITEM_PAGE))
        document.getElementById("searchResult").scrollIntoView()
    }

    return (
        <React.Fragment>
            <div className="o-grid__wrapper c-flex-bloc__spacing">
                <div className="o-grid u-justify-content-center">
                    <div className="o-grid__col is-10 is-12-s  bloc_width_100">
                        <div className="c-article-features volet">
                            {list.map((item) => {
                                return (
                                    <article key={item.id} className="o-grid__col is-6 is-6-l is-12-m c-article-item">
                                        <ItemResults item={item} openJob={openJob} />
                                    </article>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>

            {!nopage && <ReactPaginate
                previousLabel={"previous"}
                nextLabel={"next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={results.length / NP_ITEM_PAGE}
                marginPagesDisplayed={2}
                pageRangeDisplayed={1}
                onPageChange={handlePageClick}
                containerClassName={"job-result-pagination"}
                activeClassName={"active"}
            />}
        </React.Fragment>
    )
}

export default SearchResults
